<script setup lang="ts">
import { X } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps<{
    selectedCount: number
}>()

defineEmits<{
    (e: 'clear'): void
}>()
</script>

<template>
    <div
        v-if="selectedCount > 0"
        class="flex items-center flex-wrap gap-3 px-4 py-2.5 bg-teal/5 border border-teal/20 rounded-12 mb-3"
    >
        <span class="text-sm font-semibold text-teal-d">
            {{ selectedCount }}
            {{ t(selectedCount === 1 ? 'common.selectedSingular' : 'common.selectedPlural') }}
        </span>
        <div class="ml-auto flex items-center flex-wrap gap-2">
            <slot />
            <button
                type="button"
                class="w-7 h-7 rounded-6 flex items-center justify-center text-gray-500 hover:bg-gray-100"
                @click="$emit('clear')"
            >
                <X class="w-4 h-4" />
            </button>
        </div>
    </div>
</template>
